import React from "react"

function Footer () {
  let date =  new Date().getFullYear()
  
  return (
    <footer>
      <p>Copyright &copy; {date} Least1234</p>
    </footer>
  )
}

export default Footer